import { useCallback, useEffect, useRef } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { ContentTypes } from 'academy-shared-js/constants/ContentConstants';
import ApiError from '../Errors/ApiError';
import ContentControlWrapper from '../ContentControlWrapper';
import UsageTracker from '../../utils/UsageTracker';
import { isInViewport } from '../../utils/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_CLASS_NAME = 'chapter-content';
const ChapterContent = ({
  name,
  contents,
  error,
  isLoading,
  contentId,
  contentLanguage,
  trackId,
  lessonId,
  completed,
  advanceToNextContent,
  onComplete
}) => {
  const footerRef = useRef(null);
  const maybeMarkCompleted = useCallback(() => {
    if (!completed && contents) {
      onComplete();
    }
  }, [completed, contents, onComplete]);
  useEffect(() => {
    const checkProgress = () => {
      if (footerRef.current && isInViewport(footerRef.current)) {
        maybeMarkCompleted();
      }
    };
    document.addEventListener('scroll', checkProgress, true);
    checkProgress();
    return () => {
      document.removeEventListener('scroll', checkProgress, true);
    };
  }, [completed, contents, maybeMarkCompleted, onComplete]);
  const handleClickNext = () => {
    maybeMarkCompleted();
    advanceToNextContent();
  };
  const handleClickOnChapterContent = event => {
    const {
      currentTarget: target
    } = Object.assign({}, event); // event bubled up to parent;

    if (target && target.href && target) {
      if (!target.href) return;
      if (!contentId || !trackId && !lessonId) return;
      UsageTracker.track('contentInteraction', {
        action: 'open-chapter-link',
        contentId,
        contentLanguage,
        contentType: ContentTypes.CHAPTER,
        trackId,
        lessonId,
        resourceTitle: target.textContent,
        resourceUrl: target.href
      });
    }
  };
  const renderContent = () => {
    if (isLoading) {
      return /*#__PURE__*/_jsx(UILoadingSpinner, {
        grow: true
      });
    }
    if (error) {
      return /*#__PURE__*/_jsx(ApiError, {
        error: error
      });
    }
    return /*#__PURE__*/_jsx("div", {
      className: `${BASE_CLASS_NAME}__content`,
      dangerouslySetInnerHTML: {
        __html: contents || ''
      },
      "data-test-id": "chapter-html-content",
      onClick: handleClickOnChapterContent
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": BASE_CLASS_NAME,
    children: [/*#__PURE__*/_jsxs("div", {
      className: BASE_CLASS_NAME,
      children: [/*#__PURE__*/_jsx("h2", {
        className: `${BASE_CLASS_NAME}__title`,
        children: name
      }), renderContent()]
    }), /*#__PURE__*/_jsx(ContentControlWrapper, {
      className: `${BASE_CLASS_NAME}__content-control`,
      children: /*#__PURE__*/_jsx("div", {
        ref: ref => {
          footerRef.current = ref;
        },
        children: /*#__PURE__*/_jsx(UIButton, {
          onClick: handleClickNext,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.common.next"
          })
        })
      })
    })]
  });
};
export default ChapterContent;